import React from 'react';
import { SearchIcon } from '@assets/icons/index';
import { Flex, Input } from '@chakra-ui/react';
import './styles.css';

const SearchBar = ({ placeholder, onChange, ...props }) => {
    return (
        <Flex className="search-bar__container" data-testid="searchBar" {...props}>
            <SearchIcon />
            <Input placeholder={placeholder} onChange={onChange} />
        </Flex>
    );
};

export default SearchBar;
